import { render, staticRenderFns } from "./TestScoreBlock.vue?vue&type=template&id=f887b0ce&scoped=true&"
import script from "./TestScoreBlock.vue?vue&type=script&lang=js&"
export * from "./TestScoreBlock.vue?vue&type=script&lang=js&"
import style0 from "./TestScoreBlock.vue?vue&type=style&index=0&id=f887b0ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f887b0ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
